<template>
  <div id="picture-v1-cj7apy">
    <b-form-group id="picture-v1-ef7war"
      v-if="showType == 'form-builder'"
      :description="properties.description"
      :label="properties.label"
      :style="properties.style"
    >
      <div id="picture-v1-qjflhi" class="mt-2">
        <b-button id="picture-v1-e4e7he" size="sm" class="mr-2"
          ><i id="picture-v1-td4gu1" class="fa fa-camera m-1"></i>Take Picture</b-button
        >
        <b-button id="picture-v1-748knl" size="sm"
          ><i id="picture-v1-w5mocg" class="fa fa-upload m-1"></i>Upload Picture</b-button
        >
      </div>
    </b-form-group>
    <div id="picture-v1-323ywk" v-if="showType == 'properties'">
      <picture-v1-properties id="picture-v1-cdmu4m" :formId="formId" />
    </div>
    <b-form-group id="picture-v1-0vwbon"
      style="font-size: 14px"
      v-if="
        (showType == 'form-submitter' && page == currentPage) ||
        (showType == 'e-form' && properties.eFormEditable)
      "
      :description="
        computedConditions.description
          ? computedPropertiesForm.description
          : properties.description
      "
      :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      "
      :style="properties.style"
      :hidden="
        computedConditions.hidden
          ? computedPropertiesForm.hidden
          : properties.hidden
      "
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <div id="picture-v1-d6v7q9" class="picture-preview position-relative" style="height: 150px">
        <img id="picture-v1-qzlb6j"
          height="150"
          :src="
            controlValue
              ? controlValue.picture
              : require(`../../../../assets/avatar-example.png`)
          "
        />
        <div id="picture-v1-327lw4" v-if="isLoading" class="position-absolute" style="left: 60px; top: 60px;">
          <b-spinner id="picture-v1-5rlhr3" />
        </div>
      </div>
      <div id="picture-v1-5qctuo" class="mt-2">
        <b-button id="picture-v1-62zw5b" v-if="isMobile" :disabled="isLoading" class="mr-2" @click="takePicture" size="sm"
          ><i id="picture-v1-5vnu84" class="fa fa-camera m-1"></i>Take Picture</b-button
        >
        <b-button id="picture-v1-7a8by6" v-else :disabled="isLoading" class="mr-2" @click="showPictureTaker" size="sm"
          ><i id="picture-v1-en0f1b" class="fa fa-camera m-1"></i>Take Picture</b-button
        >
        <input id="picture-v1-pvmt68"
          ref="filePicture"
          @change="previewPictureFile"
          type="file"
          style="display: none"
          accept="image/*"
          capture="camera"
        />
        <canvas ref="canvas" id="canvas" width="250" height="150"></canvas>

        <input id="picture-v1-qveqry"
          ref="fileUpload"
          @change="previewFile"
          type="file"
          style="display: none"
        />
        <b-button id="picture-v1-v2mm3o" :disabled="isLoading" @click="uploadPicture" size="sm" class="mr-2"
          ><i id="picture-v1-avq88j" class="fa fa-upload m-1"></i>Upload Picture</b-button
        >
        <b-button id="picture-v1-vvdt1w"
          v-if="controlValue"
          @click="removePicture"
          :disabled="isLoading"
          size="sm"
          variant="danger"
          ><i id="picture-v1-uyjw2a" class="fa fa-trash m-1"></i>Remove Picture</b-button
        >
      </div>
      <b-modal id="picture-v1-ya8z3i"
        v-model="pictureTakerShown"
        title="Picture"
        @ok="savePicture"
        centered
        size="sm"
        no-close-on-backdrop
        header-bg-variant="primary"
        header-text-variant="white"
        header-class="bg-purple"
      >
        <template v-slot:modal-ok="{}">Take Picture</template>
        <template v-slot:modal-cancel="{}">Cancel</template>
        <div id="picture-v1-y3x6v0" class="text-center">
          <video
            ref="video"
            id="video"
            width="250"
            height="150"
            autoplay
          ></video>
        </div>
      </b-modal>
    </b-form-group>
    <b-form-group id="picture-v1-soi1e7"
      v-if="
        showType == 'form-viewer' ||
        (showType == 'e-form' && !properties.eFormEditable)
      "
      :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      "
    >
      <div id="picture-v1-nvlmm6" v-if="controlValue" class="picture-preview" style="height: 150px">
        <img id="picture-v1-m578ho" :src="controlValue.picture" />
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { formatDate, formatDateTimeSql } from "../../../../helpers/date";
import { compressImage } from "../../../../helpers/file";
import PictureV1Properties from "./PictureV1Properties.vue";
import { isMobile } from "../../../../helpers/general";
export default {
  name: "PictureV1",
  components: { PictureV1Properties },
  props: ["showType", "properties", "form", "id", "results", "formId", "page", "componentsIdSuffix"],

  data() {
    return {
      pictureTakerShown: false,
      computedProperties: ["description", "label", "hidden"],
      computedConditions: {},
      file: null,
      isMobile: isMobile(),
      isLoading: false
    };
  },
  mounted() {
    if (
      !this.getFormSubmitterComponentValue(this.id) &&
      (this.showType == "form-submitter" || this.showType == "e-form")
    ) {
      this.setFormSubmitterComponentValue({
        controlId: this.id,
        controlValue: this.properties.value
      });
      if(this.componentsIdSuffix) {
        this.initializeComponentValue({
          controlId: this.id,
          properties: this.properties
        });
      }
    }

    this.computeConditions();
  },
  methods: {
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "computeFormSubmitterValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    showPictureTaker() {
      this.pictureTakerShown = true;
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({
            video: {
              width: { min: 250, ideal: 250, max: 250 },
              height: { min: 150, ideal: 150, max: 150 }
            }
          })
          .then((stream) => {
            this.$refs.video.srcObject = stream;
            this.$refs.video.play();
          });
      }
    },
    uploadPicture() {
      this.$refs.fileUpload.click();
    },
    takePicture() {
      this.$refs.filePicture.click();
    },
    async removePicture() {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to delete this picture?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(() => {
          this.pictureTakerShown = false;
          this.controlValue = null;
          this.$refs.fileUpload.value = null;
        });
    },
    async previewPictureFile(event) {
      const file = event.srcElement.files[0];
      var self = this;
      if (file) {
        self.isLoading = true
        const options = {
          maxSizeMB: 0.5,
          maxWidthOrHeight: 900,
          useWebWorker: true
        };
        const base64 = await compressImage(file, options);
        if (base64) {
          self.controlValue = {
            picture: base64,
            date: formatDateTimeSql(self.getCurrentAdjustedDateTime())
          }
          self.isLoading = false;
        }
      }
    },
    async previewFile(event) {
      const file = event.srcElement.files[0];
      if (file) {
        this.isLoading = true
        const options = {
          maxSizeMB: 0.5,
          maxWidthOrHeight: 900,
          useWebWorker: true
        };
        const base64 = await compressImage(file, options);
        if (base64) {
          this.controlValue = {
            picture: base64,
            date: formatDateTimeSql(this.getCurrentAdjustedDateTime())
          }
          this.isLoading = false;
        }
      }
    },
    formatDate(date) {
      return formatDate(date);
    },
    savePicture(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$refs.canvas
        .getContext("2d")
        .drawImage(this.$refs.video, 0, 0, 250, 150);
      this.controlValue = {
        picture: this.$refs.canvas.toDataURL("image/png"),
        date: formatDateTimeSql(this.getCurrentAdjustedDateTime())
      };
      this.pictureTakerShown = false;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties("hidden");

      if (hidden === true) return "";

      return `
      <fieldset aria-describedby="" class="form-group">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
        ${
          this.controlValue
            ? `
          <div class="picture-preview" style="height: 150px !important;">
            <img style="max-width: 150px; max-height: 100%;" src="${this.controlValue.picture}" />
          </div>
        `
            : ""
        }
          
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: (state) => state.form.errors,
      currentPage: (state) => state.form.currentPage
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"]),
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    errors: {
      get() {
        return this.formErrors[this.id] ? this.formErrors[this.id] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden;

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>

<style scoped>
#canvas {
  display: none;
}
</style>
